import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const APPLEPAY_BY_PIQ_PAYMENT_METHOD_ENABLED: InjectionToken<boolean> = new InjectionToken<boolean>(
  'applePayByPiqPaymentMethodEnabled',
  {
    factory: () => false
  }
);
